<i18n src="@/translations/ReferenceHandler.json"></i18n>
<template>
  <div class="d-inline-block">
    <slot/>
    <v-menu v-model="show"
            :close-on-content-click="false"
            :max-width="336"
            :position-x="positionX"
            :position-y="positionY"
    >
      <v-card @click="entryClicked(activeRef)">
        <div v-if="activeRef" class="tooltip-content" @mouseenter="showTooltip" @mouseleave="hideTooltip">
        <span class="glossar-content">
          <fin-data-loader :params="activeRef" :resolver="loadTooltip">
            <template #content="{data}">
               <entry-display small :entry="data"/>
            </template>
          </fin-data-loader>
        </span>
          <v-btn class="pl-0" style="height: 12px" text>
            <span style="color: #ffffff; font-weight: bold;">{{ $t('ReferenceHandler.click_for_more_info') }}</span>
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import EntryDisplay from "@/components/common/lexicon/LexiconOverlay/EntryDisplay"
import LexiconAPI from "@/components/common/lexicon/LexiconAPI"

export default {
  name: "ReferenceHandler",
  components: {EntryDisplay, FinDataLoader},
  data: () => ({
    show: false,
    positionX: 0,
    positionY: 0,
    activeRef: null,
    hideFunction: null
  }),
  mounted() {
    this.$el.addEventListener('click', this.click)
    this.$el.addEventListener('mouseover', this.mouseover)
    this.$el.addEventListener('mouseout', this.mouseout)
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.click)
    this.$el.removeEventListener('mouseover', this.mouseover)
    this.$el.removeEventListener('mouseout', this.mouseout)
  },
  methods: {
    loadTooltip: LexiconAPI.loadTooltip,
    entryClicked(ref) {
      this.show = false
      this.$emit('entryClicked', {ref})
    },
    click(event) {
      if (!event.target.matches('.crossref')) return
      event.preventDefault()
      event.stopPropagation()
      this.entryClicked(event.target.dataset.to)
    },
    mouseover(event) {
      if (!event.target.matches('.crossref')) return
      this.activeRef = event.target.dataset.to

      // let dataValue = e.target.getAttribute('data-key')
      // EventBus.$emit('showLexicon', dataValue, this.onlyEntry)
      this.positionX = event.clientX - 10
      this.positionY = event.clientY + 15
      this.showTooltip()
    },
    mouseout(event) {
      if (!event.target.matches('.crossref')) return
      this.hideTooltip()
    },
    showTooltip() {
      clearTimeout(this.hideFunction)
      this.show = true
    },
    hideTooltip() {
      this.hideFunction = setTimeout(() => {
        this.show = false
      }, 300) // delay
    }
  }
}
</script>

<style scoped>
::v-deep .crossref {
  border-bottom: 1px dotted;
  cursor: pointer;
}


.glossar-content {
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.tooltip-content {
  padding: 5px;
}

::v-deep .v-card {
  color: #ffffff !important;
  background-color: #393b51 !important;
}
</style>
